import React from 'react';

const ExpSubsection = ({ borders = 'border-ba', children, className = 'border-green-600 border-opacity-20 pb-6 mt-8 bg-red-100a' }) => {
    return <div className={`${className} ${borders}`}>{children}</div>;
};

export default ExpSubsection;
